import { Box } from "@mui/material"
import { useFocusable } from "@noriginmedia/norigin-spatial-navigation"
import clsx from "clsx"
import React, { ReactNode, useEffect, useState } from "react"

import { appStore } from "../../store/AppStore"
import { focusStore } from "../../store/FocusStore"
import { s } from "../../utilities/common"
import {
  deviceResolution,
  fontSizeFactor,
  nonStandardFormat,
} from "../../utilities/constants"

import "./Tab.css"

export const Tab = ({
  width,
  svg = false,
  children,
  route,
}: {
  svg?: boolean
  width?: number
  children: ReactNode | string
  route: string
}) => {
  const setSlug = appStore((state) => state.setSlug)
  const slug = appStore((state) => state.slug)
  const tabBarSlug = focusStore((state) => state.tabBarSlug)
  const setTabBarSlug = focusStore((state) => state.setTabBarSlug)

  const [highlighted, setHighlighted] = useState(false)
  const [touched, setTouched] = useState(false)
  const onFocus = () => {
    setHighlighted(true)
    if (route === slug) return
    setSlug(route)
    setTabBarSlug(route)
  }

  useEffect(() => {
    if (route !== tabBarSlug) {
      setHighlighted(false)
    }
  }, [tabBarSlug])

  const { ref, focused, focusSelf } = useFocusable({
    focusKey: "TABBAR:" + route,
    onFocus,
  })

  return (
    <Box
      aria-label={slug}
      tabIndex={0}
      onMouseEnter={() => setTouched(true)}
      onMouseLeave={() => setTouched(false)}
      onMouseDown={() => {
        focusSelf()
        onFocus()
      }}
      ref={ref}
      className={clsx(
        "Tab",
        svg && "Svg",
        focused && "focused",
        highlighted && "highlighted",
        touched && "touched",
        deviceResolution === 720 && "small",
      )}
      style={{
        fontSize: s("30px", false, fontSizeFactor),
        lineHeight: s("57px"),
        width: width ? width + "px" : undefined,
        ...(nonStandardFormat
          ? {
              borderRadius: s("36px"),
              height: s("60px"),
              paddingLeft: s("20px"),
              paddingRight: s("20px"),
              border: `${s("2px")} solid #0a0f17`,
            }
          : {}),
      }}
      sx={{
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {typeof children === "string"
        ? children
        : React.Children.map<ReactNode, ReactNode>(children, (child) => {
            if (React.isValidElement(child)) {
              return React.cloneElement(
                child,
                // @ts-expect-error // TODO FIXME
                child.type !== "span" ? { focused } : undefined,
              )
            }
          })}
    </Box>
  )
}
